import axios from 'axios';

import { MainUrl } from "../constants"

const API_URL = `${MainUrl}/post`


export const PostGet = async (token, postId) => {
  const response = await axios.get(`${API_URL}/${postId}`, {
    headers: {
      Authorization: `Bearer ${token}`
    }
  });
  return response.data;
};

export const GetAccessPosts = async (token) => {
  const response = await axios.get(`${API_URL}/all_posts/`, {
    headers: {
      Authorization: `Bearer ${token}`
    }
  });
  return response.data;
};

export const GetPosts = async (token, page, limit) => {
  const response = await axios.post(`${API_URL}/posts?page=${page}&limit=${limit}`, {}, {
    headers: {
      Authorization: `Bearer ${token}`
    }
  });
  return response.data;
};

export const CreatePost = async (token, {name, is_active, bk_name, access_level, price}) => {
  
  const body = {name, is_active, bk_name, access_level, price}
  const response = await axios.post(`${API_URL}/`, body, {
    headers: {
      Authorization: `Bearer ${token}`
    }
  });
  return response.data;
};

export const DeletePost = async (token, id) => {
  
  const response = await axios.delete(`${API_URL}/${id}`, {
    headers: {
      Authorization: `Bearer ${token}`
    }
  });
  return response.data;
};

export const UpdatePost = async (token, {id, name, is_active, bk_name, access_level, price}) => {
try {
  const body = {name, is_active, bk_name, access_level, price}
  const response = await axios.patch(`${API_URL}/${id}`, body, {
    headers: {
      Authorization: `Bearer ${token}`
    }
  });
  return response.data;
}
catch(error){
  return error.response
}

}